import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { MessageService } from 'primeng/api';

import { AuthTokenService } from '@core/services/auth-token.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private readonly router = inject(Router);
  private readonly authTokenService = inject(AuthTokenService);
  private readonly messageService = inject(MessageService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | UrlTree {
    return of(this.authTokenService.getTokenData()).pipe(
      switchMap(async token => {
        const returnUrl = state.url;

        if (!token) {
          this.authTokenService.deleteAll();
          return this.goToLogin(returnUrl);
        }

        if (this.authTokenService.isTokenExpired()) {
          this.authTokenService.deleteAll();
          await this.showMessage();
          return this.goToLogin(returnUrl);
        }

        return true;
      })
    );
  }

  async goToLogin(returnUrl: string) {
    return this.router.createUrlTree(['/login'], { queryParams: { returnUrl } });
  }

  async showMessage() {
    this.messageService.add({
      severity: 'warn',
      summary: 'Su sesión ha expirado.',
      detail: 'Por favor, vuelva a iniciar sesión.',
      life: 5000,
    });
  }
}
